/* THE ONE WRITE OF NEXT WEEK'S NUMBERS — one column, one value, exactly the set rows named (W72 step 2's `Hold at 60`,
 * extracted in W82 step 4 so the review's Next-week column writes through the SAME function, never a second one).
 *
 * The rows are the client-scoped COPY's `coach_workout_sets` (copy-on-assign, V7-2) — next week's prescription, which the
 * phone reads on the day. A write names the column it moves and nothing else; the screen re-reads the tree from the server
 * after it (never a local shadow of the value: two stores of one fact, and a Hold the database refused would still show).
 *
 * ⚠️ THE FIRST REFUSAL STOPS THE LOOP and the result says how many landed before it — carrying on would leave a coach with
 * half of next week written and a sentence about the last row only (`ExerciseSetWindow.save`'s rule). */

export type SetColumn = "reps" | "weight_kg" | "time_seconds";
export type SetFieldWrite = { readonly column: SetColumn; readonly value: number; readonly ids: readonly string[] };

/** The database half, injected so the order and the stop are tested without a network. */
export type SetUpdate = (payload: { reps: number } | { weight_kg: number } | { time_seconds: number }, ids: readonly string[]) => PromiseLike<{ error: { message: string } | null }>;

export function payloadOf(w: SetFieldWrite): { reps: number } | { weight_kg: number } | { time_seconds: number } {
  // ONE column, spelled per case so the typed client checks it.
  return w.column === "reps" ? { reps: w.value } : w.column === "weight_kg" ? { weight_kg: w.value } : { time_seconds: w.value };
}

export async function applySetFieldWrites(update: SetUpdate, writes: readonly SetFieldWrite[]): Promise<{ landed: number; error: string | null }> {
  let landed = 0;
  for (const w of writes) {
    if (w.ids.length === 0) continue;
    const { error } = await update(payloadOf(w), w.ids);
    if (error !== null) return { landed, error: error.message };
    landed += 1;
  }
  return { landed, error: null };
}
